import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './style.module.css';
import { DropdownArrow } from 'assets/icons';
import { CircularProgress } from '@mui/material';
import BackButton from 'layouts/RegistrationLayoutNew/Buttons/BackButton';

const SelectPlanSection = ({
  selectedClub,
  newOlsPlans,
  selectedPlan,
  setSelectedPlan,
  onNext,
  onBack,
  isMobile,
  isSmallMobile,
  membershipPlanInfo,
  resetArrayState,
}) => {
  const [isShowPlans, setShowPlans] = useState(false);
  const [selectedIndices, setSelectedIndices] = useState([]);
  const handleBack = () => {
    resetArrayState('newOlsPlans');
    setShowPlans(false);
    onBack();
  };

  const handleToggle = index => {
    if (selectedIndices.includes(index)) {
      setSelectedIndices(selectedIndices.filter(i => i !== index));
    } else {
      setSelectedIndices([...selectedIndices, index]);
    }
  };

  const handleSelectCard = (id, index) => {
    setSelectedPlan(id);
    if (isMobile) {
      handleToggle(index);
    }
  };

  const clubPlans = (Object.keys(membershipPlanInfo).length !== 0
    ? membershipPlanInfo.data.planData
    : newOlsPlans
  )
    .map(({ id, name, price, description }) => {
      const type = name && name.toLowerCase().includes('month') ? 'monthly' : 'annually';
      const planName = name && name.replace(/\([^)]+\)/, '').split('-')[1];
      const formattedPrice = `$${price}`;

      return {
        id,
        type,
        name: planName,
        price: formattedPrice,
        description,
      };
    })
    .sort((a, b) => {
      const priceA = parseFloat(a.price.slice(1));
      const priceB = parseFloat(b.price.slice(1));
      return priceA - priceB;
    });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const currentPlans = (Object.keys(membershipPlanInfo).length !== 0
      ? membershipPlanInfo.data.planData
      : newOlsPlans
    ).filter(el =>
      el.locationIds.some(
        i =>
          parseInt(i) ===
          (Object.keys(membershipPlanInfo).length !== 0
            ? parseInt(membershipPlanInfo.data.clubId)
            : +selectedClub?.clubautomationclubidC)
      )
    );

    if (currentPlans?.length > 0) {
      setShowPlans(true);
    } else {
      setShowPlans(false);
    }
  }, [selectedClub, newOlsPlans, membershipPlanInfo]);

  return isShowPlans === true ? (
    <>
      <div className={`${styles.body} ${isMobile ? styles.mobile : ''}`}>
        {clubPlans.map((c, index) => (
          <>
            <div
              className={`${styles.wrapper} ${selectedPlan === c.id}`}
              key={c.id}
              onClick={() => handleSelectCard(c.id, index)}
            >
              <div
                value={selectedPlan === c.id}
                className={`
                ${styles.card} ${isMobile ? styles.mobile : ''}${
                  selectedIndices.includes(index) ? styles.expand : ''
                } ${isSmallMobile ? styles.smallMob : ''}

                `}
              >
                <h1 className={`${styles.planName}`}>{c.name}</h1>
                <div className={styles.innerWrapper}>
                  <div className={styles.priceWrappper}>
                    <p className={styles.planPrice}>{c.price}</p>
                    <p className={styles.planPriceDescription}>
                      Monthly recurring payment
                    </p>
                  </div>
                  <div className={styles.SelectBtnWrapper}>
                    <button onClick={onNext} className={styles.selectBtn}>
                      Select
                    </button>
                  </div>
                  <div>
                    {isMobile && !selectedIndices.includes(index) ? (
                      <img
                      alt=''
                        key={index}
                        onClick={() => handleToggle(index)}
                        src={DropdownArrow}
                      />
                    ) : null}
                  </div>
                  <div
                    className={`${styles.descriptionWrapper} ${
                      isMobile ? styles.mobile : ''
                    } ${isMobile && selectedIndices.includes(index) ? styles.show : ''}`}
                  >
                    <h1 className={styles.descriptionHeading}>
                      {c.name.includes('Premier') ? (
                        <>Includes All Gym Access, plus:</>
                      ) : (
                        <>Includes :</>
                      )}
                    </h1>
                    <p className={styles.description}>
                      Access to <span>{selectedClub?.displayName}</span>
                      <br />
                      Group Fitness Classes <br /> Full Locker Rooms <br /> Towel Service
                      <br />
                      FITNESS SF App <br />
                    </p>
                    <p className={styles.nutrition}>(includes Nutrition)</p>
                  </div>
                </div>
              </div>
            </div>
          </>
        ))}
      </div>
      {Object.keys(membershipPlanInfo).length === 0 ? (
        <BackButton onBack={() => handleBack()} backButtonName="Back" />
      ) : null}
    </>
  ) : (
    <div className={styles.progressbarDiv}>
      <CircularProgress
        className={styles.circularProgress}
        style={{ color: '#fe5000' }}
      />
    </div>
  );
};

SelectPlanSection.propTypes = {
  selectedClub: PropTypes.string.isRequired,
  newOlsPlans: PropTypes.array.isRequired,
  selectedPlan: PropTypes.string.isRequired,
  setSelectedPlan: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

SelectPlanSection.defaultValue = {
  newOlsPlans: [],
};

export default SelectPlanSection;
